'use client';

import type { IconSize } from '../icons/icon';

import { cn } from '@polyseme/utils/cn/cn-utils';

import { Icon } from '../icons/icon';

type Props = {
  className?: string;
  size?: IconSize;
};

export const LoaderCircle = ({ className, size = 'xl' }: Props) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <Icon className="animate-spin" name="loader-circle" size={size} />
    </div>
  );
};
